import axios from "axios";
import { __constants } from "../../constants";
const BASE_URL = process.env.REACT_APP_SERVER_URL;

/* Seeker Management */
export const getSeekersNeedsController = async () => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + "/v1/admin/seekerneed",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in getSeekersNeedsController >> ", err.message);
        return err.response
    }
}

export const AddSeekersNeedsController = async (name, file,greyImage) => {
    try {
        var formdata = new FormData();
        formdata.append("name", name);
        formdata.append("file", file);
        formdata.append("greyImage", greyImage);
        const config = {
            method: 'POST',
            url: BASE_URL + "/v1/admin/add-seekerneed",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
            data: formdata
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in AddSeekersNeedsController >> ", err.message);
        return err.response
    }
}